/**
 * 人像资产状态的纯常量与合并逻辑。
 *
 * 独立于 services/hooks 层：画布 layout 计算等纯模块需要它，
 * 但不能因此把 apiClient / zustand store 拉进依赖链。
 */

export const AI_ASSET_STATUS = {
  PROCESSING: 0,
  ACTIVE: 1,
  FAILED: 2,
} as const;

export type AiAssetStatus = (typeof AI_ASSET_STATUS)[keyof typeof AI_ASSET_STATUS];

export type HumanAssetBindingState = 'processing' | 'active' | 'failed' | null;

/** 本地态优先于服务端持久化状态，保证提交后立刻反馈、刷新后仍可回显 */
export function resolveHumanAssetBindingState(
  persistedStatus: number | null | undefined,
  localState: HumanAssetBindingState
): HumanAssetBindingState {
  if (localState) return localState;
  if (persistedStatus === AI_ASSET_STATUS.PROCESSING) return 'processing';
  if (persistedStatus === AI_ASSET_STATUS.ACTIVE) return 'active';
  if (persistedStatus === AI_ASSET_STATUS.FAILED) return 'failed';
  return null;
}
